import classNames from 'classnames';

import styles from './Hamburger.module.scss';

type HamburgerProps = { open?: boolean; className?: string };
const Hamburger = ({ open, className }: HamburgerProps) => {
  return (
    <div className={classNames(styles.hamburger, className, { [styles.open]: open })}>
      <span className={styles.bar} />
      <span className={styles.bar} />
      <span className={styles.bar} />
    </div>
  );
};

export default Hamburger;
